import { Link } from "react-router-dom";

import { useEffect, useState } from "react";

const frases = [
  "GÉMINIS SEGURIDAD",
  "tu seguridad inteligente",
  "soluciones profesionales",
  "innovación en protección"
];



function Home() {

  const [fraseActual, setFraseActual] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setFraseActual((prev) => (prev + 1) % frases.length);
    }, 8000); // cambia cada 2.5 segundos

    return () => clearInterval(intervalo);
  }, []);



  return (
    <div className="container my-5">
      {/* Encabezado */}
      <section className="text-center mb-5">
        <h1 className="mb-3 text-warning text-center">
          Bienvenidos a{" "}
          <span
            key={fraseActual}
            className="d-inline-block fade-in title-animated"
            
          >
            {frases[fraseActual]}
          </span>
        </h1>
        <h2 className="lead text-white bg-dark d-inline-block px-3 py-2 rounded">
          Protección inteligente para un mundo en constante cambio.
        </h2>

      </section>

      {/* Imagen + presentación */}
      <section className="row align-items-center mb-5 bg-white text-white p-4 rounded shadow-sm">
        <div className="col-md-6 text-center mb-4 mb-md-0">
          <img
            src="/img/logos/logo_nobg.png"
            alt="Sistema de seguridad moderno"
            className="img-fluid"
           
          />
        </div>
        <div className="col-md-6 text-dark">
          <h4 className="mb-3 text-warning">Tecnología + Compromiso humano</h4>
          <p>
            En <strong>GÉMINIS</strong> creemos que la seguridad no se improvisa. Diseñamos soluciones reales, adaptadas a vos, con tecnología de última generación y un equipo que responde con responsabilidad.
          </p>
          <p>
            Te brindamos más que vigilancia: te damos respaldo, velocidad de respuesta y un trato humano.
          </p>
        </div>
      </section>

      {/* Accesos a otras secciones */}
      <section className="text-center mb-5">
        <h2 className="text-warning mb-4">Explorá nuestros servicios</h2>
        <div className="row gy-4">
          <div className="col-md-4">
            <div className="p-4 border rounded bg-white shadow-sm h-100">
              <h5 className="text-dark mb-3">Nuestros Productos</h5>
              <p>Descubrí alarmas, sensores, cámaras y más tecnologías para proteger lo que más querés.</p>
              <Link to="/productos" className="btn btn-warning text-dark fw-bold">
                Ver productos
              </Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="p-4 border rounded bg-white shadow-sm h-100">
              <h5 className="text-dark mb-3">Servicios Profesionales</h5>
              <p>Instalación, monitoreo, soporte técnico y asesoramiento. Un equipo a tu lado.</p>
              <Link to="/servicios" className="btn btn-warning text-dark fw-bold">
                Ver servicios
              </Link>
            </div>
          </div>

          <div className="col-md-4">
            <div className="p-4 border rounded bg-white shadow-sm h-100">
              <h5 className="text-dark mb-3">Área Cliente</h5>
              <p>Accedé a tu cuenta, gestiona tu sistema o recibí asistencia desde nuestra plataforma.</p>
              <Link to="/area-cliente" className="btn btn-warning text-dark fw-bold">
                Ingresar
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Llamado final */}
      <section className="text-center mt-5 py-5 bg-dark text-white rounded shadow-sm">
        <h2 className="text-warning mb-3">Estamos para ayudarte</h2>
        <p className="lead">¿Querés más información o agendar una visita técnica?</p>
        <Link to="/contacto" className="btn btn-warning text-dark fw-bold mt-2">
          Contactanos ahora
        </Link>
      </section>

      {/* Nuestra misión */}
      <section className="mb-5">
        <div className="bg-white p-4 rounded shadow-sm">
          <h2 className="text-warning mb-3 text-center heading-underline-warning">Nuestra misión</h2>
          <p className="text-dark fs-5 text-center">
            En <strong>GÉMINIS SEGURIDAD</strong> trabajamos con un propósito claro: brindar tranquilidad a las personas.
            Diseñamos sistemas de protección que se adaptan a cada cliente, priorizando la eficiencia, la cercanía y la confianza mutua.
          </p>
          <p className="text-dark text-center">
            Sabemos que detrás de cada alarma hay una familia, un sueño o un proyecto. Por eso,
            te acompañamos con compromiso, innovación y responsabilidad.
          </p>
        </div>
      </section>
      <section className="text-center mb-5">

        <h4 className="fw-semibold text-warning mt-3">
          Tu seguridad, nuestra prioridad.
        </h4>
      </section>
    </div>
  );
}

export default Home;
